import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, ArrowRight } from 'lucide-react';
import { Breadcrumb } from '../initiatives/Breadcrumb';
import { cognocracyEmblem } from '../../data/initiatives';
import { easeOutStrong } from '../../utils/motion';
const focusRing = 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal';
export function CognocracyHero() {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-262" data-mp="1o063q9o197w5">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: easeOutStrong
    }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-263" data-mp="1s1hmpwceiuvd">
        <Breadcrumb items={[{
        label: 'Home',
        href: '/'
      }, {
        label: 'Projects',
        href: '/projects'
      }, {
        label: 'Cognocracy'
      }]} data-id="element-264" data-mp="21zxf02n60a6g" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-265" data-mp="3dc82pun1xg41">
          <div className="lg:col-span-7" data-id="element-266" data-mp="1t3cccdu48loz">
            <p className="text-sm font-medium text-teal mb-5" data-id="element-267" data-mp="1p329vb5j8dev">Civic Governance</p>
            <h1 className="font-heading font-extrabold text-5xl lg:text-6xl text-ink-dark leading-[1.05] tracking-tight" data-id="element-268" data-mp="1p0xtvuuczny8">
              Cognocracy
            </h1>
            <p className="mt-5 font-heading font-semibold text-xl lg:text-2xl text-navy leading-snug" data-id="element-269" data-mp="1f42yhktdu3o6">
              Developing human capability. Advancing civic judgment.
            </p>
            <p className="mt-8 text-lg lg:text-xl text-ink-dark leading-relaxed" data-id="element-270" data-mp="15e08lthk55u2">
              Cognocracy brings together connected knowledge, human development and institutional learning to explore
              a more capable system of civic governance. Powered by SyNeural, the framework connects assessment,
              development pathways and credentials with readiness for greater responsibility.
            </p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-271" data-mp="mgqmg4kule94">A SyNeural project under development.</p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-272" data-mp="cr06xsgjprn7">
              <a href="#framework" className={`inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap ${focusRing}`} data-id="element-273" data-mp="hry01033g63h">
                Explore the framework
                <ArrowDown size={18} aria-hidden="true" data-id="element-274" data-mp="vkdvnfto11ud" />
              </a>
              <a href="/government" className={`inline-flex items-center justify-center gap-2 border border-line text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap ${focusRing}`} data-id="element-275" data-mp="10ip7tx7fnofr">
                See the government solution
                <ArrowRight size={18} aria-hidden="true" data-id="element-276" data-mp="1egdn8piqe3df" />
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 flex justify-center" data-id="element-277" data-mp="1j9yi48p12h8e">
            <img src={cognocracyEmblem.src} alt={cognocracyEmblem.alt} className="w-full max-w-[220px] sm:max-w-[280px] lg:max-w-[420px] aspect-square object-contain" data-id="element-278" data-mp="33y0ut7aqx8jt" />
          </div>
        </div>
      </motion.div>
    </section>;
}